import { Companion_getInstancel4ymxmn2l08f as Companion_getInstance } from '../../../../../../lightning-server-core-shared/com/lightningkite/lightningserver/HttpMethod.mjs';
import {
  Companion_getInstance3jr0y3h9aenfk as Companion_getInstance_0,
  Companion_getInstance2dipyncjirnxu as Companion_getInstance_1,
  Companion_getInstance35gn67k9ocaua as Companion_getInstance_2,
} from '../sessionModels.mjs';
import { Companion_instance1xo6qhmbc85vh as Companion_instance } from './proofModels.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1x79l67jvwntn as serializer,
  serializer1cdzkc3mnhoc4 as serializer_0,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LiveAuthClientEndpointsClass;
function LiveAuthClientEndpoints() {
  if (LiveAuthClientEndpointsClass === VOID) {
    class $ {
      constructor(fetcher, subpath, subjectSerializer, idSerializer) {
        this.fetcher_1 = fetcher;
        this.subpath_1 = subpath;
        this.subjectSerializer_1 = subjectSerializer;
        this.idSerializer_1 = idSerializer;
      }
      *logInV2_lw4xp7_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/login2', Companion_getInstance().POST_1, Companion_getInstance_0().serializer_9w0wvi_k$(), input, Companion_getInstance_1().serializer_af6cag_k$(this.idSerializer_1), $completion);
      }
      *checkProofs_qk2dxf_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/proofs-check', Companion_getInstance().POST_1, ListSerializer(Companion_instance.serializer_9w0wvi_k$()), input, Companion_getInstance_2().serializer_af6cag_k$(this.idSerializer_1), $completion);
      }
      *getTokenSimple_ybyi9u_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/token/simple', Companion_getInstance().POST_1, serializer(StringCompanionObject_instance), input, serializer(StringCompanionObject_instance), $completion);
      }
      *getSelf_ivto1e_k$($completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/self', Companion_getInstance().GET_1, serializer_0(Unit_instance), Unit_instance, this.subjectSerializer_1, $completion);
      }
      *terminateSession_ckz0qq_k$($completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/terminate', Companion_getInstance().POST_1, serializer_0(Unit_instance), Unit_instance, serializer_0(Unit_instance), $completion);
      }
    }
    initMetadataForClass($, 'LiveAuthClientEndpoints', VOID, VOID, VOID, [1, 0]);
    LiveAuthClientEndpointsClass = $;
  }
  return LiveAuthClientEndpointsClass;
}
//region block: exports
export {
  LiveAuthClientEndpoints as LiveAuthClientEndpoints3n10lw5s4xv4t,
};
//endregion

//# sourceMappingURL=LiveAuthClientEndpoints.mjs.map
